import Config from "../../../Configs";
import { ApiResponse, CreateCFPMetaRequest, CrfCalculationStatus } from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export class CFPService extends ApiServiceBase {
    constructor(client: IHttpService) {
        super(client);
    }

    initiateCalculation(savedItemId: number) {
        return this._client.get(Config.apiPaths.calculateCFP.replace("{0}", savedItemId.toString()));
    }

    checkCalulcationStatus(calculationId: string): Promise<ApiResponse<CrfCalculationStatus>> {
        return this._client.get<CrfCalculationStatus>(Config.apiPaths.checkCalculationStatus.replace("{0}", calculationId));
    }

    collectCalculationData(calculationId: string): Promise<ApiResponse<string>> {
        return this._client.post(Config.apiPaths.collectCrfData.replace("{0}", calculationId));
    }

    storeCalculationData(content: CreateCFPMetaRequest) {
        return this._client.post<boolean>(Config.apiPaths.storeCrfData, content);
    }
}
